const graphContainer = $("#graph_container")
const classList = ".systems-show, .dashboard-index"
const controllerAndAction = document.getElementById("current-controller-and-action")
if (controllerAndAction.matches(classList) && graphContainer.length > 0) {
  $.getJSON(graphContainer.data("url"), function (data) {
    let ctx, scrollRight
    if (data.generation && data.generation.length > 0) {
      ctx = $("#myChart")
      new Chart(ctx, {
        type: "bar",
        data: {
          labels: data.months,
          datasets: [
            {
              label: "Total Credited kWh",
              data: data.cumulative,
              monthly: data.generation,
              barThickness: 60,
              barPercentage: 0.8,
              categoryPercentage: 0.8,
              backgroundColor: "rgb(124, 181, 236)"
            }
          ]
        },
        options: {
          scales: {
            xAxes: {
              gridLines: {
                offset: false
              }
            }
          },
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          tooltips: {
            backgroundColor: "rgba(251, 232, 170, .8)",
            xPadding: 16,
            yPadding: 16,
            titleFontSize: 16,
            titleFontColor: "#3598db",
            bodyFontColor: "black",
            bodyFontSize: 14,
            cornerRadius: 8,
            displayColors: false,
            callbacks: {
              title: function (tooltipItem, data) {
                return data.labels[tooltipItem[0].index]
              },
              label: function (tooltipItem, data) {
                return data.datasets[0].data[tooltipItem.index] + " kWh production to date"
              },
              afterLabel: function (tooltipItem, data) {
                return data.datasets[0].monthly[tooltipItem.index] + " kWh this month"
              }
            }
          }
        }
      })

      $("#chartAreaWrapper").css("width", data.months.length * 100 + "px")

      scrollRight = function (targetElement, speed) {
        const scrollWidth = $(targetElement).get(0).scrollWidth
        const clientWidth = $(targetElement).get(0).clientWidth
        return $(targetElement).animate({
          scrollLeft: scrollWidth - clientWidth
        }, {
          duration: speed,
          complete: function () {
            return targetElement.animate({
              scrollLeft: scrollWidth
            }, {
              duration: speed
            })
          }
        })
      }
      return scrollRight($(".chartWrapper"), data.months.length * 10)
    } else {
      return $("#myChart").hide()
    }
  })
}
